<script setup>
import { computed } from 'vue'
import { useAppearanceStore } from '@state/stores/appearance'
import Logo from '@components/logo'

const appearanceStore = useAppearanceStore()

const isMenuOpen = computed(() => appearanceStore.isMainMenuOpen)

function toggleMenu() {
    appearanceStore.toggleMainMenu()
}

function closeMainMenu() {
    appearanceStore.closeMainMenu()
}
</script>

<template>
    <div class="menu-bar">
        <div
            v-click-outside="closeMainMenu"
            class="menu-button"
            @click="toggleMenu"
        >
            <span :class="['button-line', { active: isMenuOpen }]" />
        </div>

        <Logo :has-margin="false" />
        <BaseLink
            class="title"
            :to="{ name: 'search' }"
            aria-label="Go to Search Page"
        >
            <BaseIcon
                class="search-icon"
                name="search"
            />
        </BaseLink>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

// `position` is deliberately absent: layouts/main-layout.vue passes this component a `menu-bar` class of
// its own and makes it `position: sticky`, which is what the page actually renders.
.menu-bar {
    z-index: $layer-dropdown-z-index;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: $size-menu-bar-height;
    padding: gutter();
    text-align: center;
}

.button-line {
    position: relative;
    display: inline-block;
    width: 16px;
    height: 2px;
    vertical-align: middle;
    background: $c-accent-default;

    &::before {
        position: absolute;
        top: -5px;
        left: 0;
        width: 16px;
        height: 2px;
        content: '';
        background: $c-accent-default;
    }

    &::after {
        position: absolute;
        top: 5px;
        left: 0;
        width: 16px;
        height: 2px;
        content: '';
        background: $c-accent-default;
    }

    &.active {
        background: transparent;

        &::before {
            top: 0;
            transform: rotate(45deg);
        }

        &::after {
            top: 0;
            transform: rotate(-45deg);
        }
    }
}

.title {
    margin: 0;
    font-size: 16px;
    font-weight: 800;
    line-height: $size-menu-bar-height - gutter() * 2;
    vertical-align: middle;
    color: $c-white;
}

.search-icon {
    position: absolute;
    top: 50%;
    right: 30px;
    width: 20px;
    height: 20px;
    color: $c-text-tertiary;
    transform: translateY(-50%);
}

@media (min-width: $desktop) {
    .menu-bar {
        display: none;
    }
}
</style>
